import React from 'react'
import { Webinars, SEO, StarsSection } from 'newComponents'
import Layout from '../../../components/layout'

import '../../../styles/thanks.scss'

const WebinarConfirmationLanding = () => (
  <Layout>
    <SEO title="Thank You" description="" />
    <StarsSection className="section bg-dark">
      <div className="container content columns">
        <div className="column docking-thanks-hero is-12 has-text-centered has-text-left-mobile u-margintop-large-desktop u-marginbottom-large-desktop">
          <h1 className="title">Thanks for Contacting Us</h1>
          <p className="subtitle-hero webinar-subtitle">
            You'll receive an email with a link to the on-demand webinar
            shortly.
          </p>
        </div>
      </div>
    </StarsSection>
    <Webinars
      hideFutureWebinars
      confirmationPage
      pastTitle="Webinars You May Like"
      pastContent="Missed a live session? Listen to the on-demand recording."
    />
  </Layout>
)

export default WebinarConfirmationLanding
